let platform = (function () {
    let {userAgent} = window.navigator;
    if (userAgent.indexOf("miniProgram") !== -1 ||
        userAgent.indexOf("wxwork") !== -1
    ) {
        platform = 'wx'
    } else if (userAgent.toLowerCase().indexOf("dingtalk") !== -1) {
        platform = 'dd'
    } else if (userAgent.indexOf("QYZone") !== -1) {
        platform = 'upesn'
    } else if (/(iPhone|iPad|iPod|iOS|Android)/i.test(userAgent)) {
        // 移动端浏览器切换
        platform = 'h5_ucg'
    } else {
        platform = 'h5'
    }
    console.log(platform);
    return platform;
})();

let isUcg = (function () {
    let {pathname} = window.location;
    return pathname.indexOf('/ncc_mobile') > -1;
})();

export {
    platform,
    isUcg
};